import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ScriptPreferencesDialogComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/dialogs/script-preferences-dialog.component';

@Component({
  selector: 'checkout-script-preferences',
  templateUrl: './checkout-script-preferences.html',
  styleUrls: ['./checkout-script-preferences.scss'],
  standalone: false,
})
export class CheckoutScriptPreferences {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  @Input() settings: CheckoutSettings;
  constructor(private dialog: MatDialog) {}

  handleToggle(event: boolean | null): void {
    if (event || event === null) {
      const dialogRef = this.dialog.open(ScriptPreferencesDialogComponent, {
        autoFocus: false,
      });
      dialogRef
        .afterClosed()
        .pipe(first())
        .subscribe((result) => {
          this.formGroup.patchValue({ scriptTagEnabled: !!result });
          this.formGroup.markAsDirty();
        });
    }
  }
}
